import { Box } 
  from "@mui/material";

/**
 * @param {object} props
 * @param {React.ReactNode} props.children - The content to be displayed within the panel.
 * @param {number} props.index - The index of this specific panel.
 * @param {number} props.value - The currently active tab value.
 * @param {object} [props.sx] - Optional custom styling for the content Box.
 */
function GeneralTabPanel(props) {
    const { children, value, index, sx, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            style={{ flexGrow: 1, overflow: 'hidden' }}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 2, height: '100%', overflowY: 'auto', ...sx }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

export default GeneralTabPanel;